/* eslint-disable camelcase */
export default {
  title: "Основные данные",
  profile_updated: "Профиль успешно обновлён",
  unknown_error: "Произошла неизвестная ошибка при редактировании профиля",
};
